import { Trash2 } from "lucide-react";

import { useLayoutMode } from "@/modules/mine";
import { ItemSkeleton } from "@/modules/mine/components/item-skeleton";

export function TrashPageLoading() {
  const layoutMode = useLayoutMode();

  return (
    <div>
      <div className="flex items-center gap-2 pb-4 pt-2 text-2xl font-black tracking-tight">
        <Trash2 className="size-6" />
        回收站
      </div>
      <ItemSkeleton count={12} mode={layoutMode} />
    </div>
  );
}
